export function dataInRequest(params = {}) {
  return {
    type: '@inversorFrequencia/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@inversorFrequencia/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@inversorFrequencia/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@inversorFrequencia/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@inversorFrequencia/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@inversorFrequencia/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@inversorFrequencia/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@inversorFrequencia/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@inversorFrequencia/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@inversorFrequencia/RECORD_FILTERING',
    payload: { params },
  };
}
